import * as React from 'react'

function CopyIcon() {
  return (
    <svg width="40" height="40" version="1.1" viewBox="0 0 24 24">
      <g
        strokeLinecap="round"
        strokeWidth="0.5"
        stroke="#1F2D27"
        fill="none"
        strokeLinejoin="round"
      >
        <path d="M8.4,17.02h4.417c0.552,0 1,-0.448 1,-1v-5.29c0,-0.552 -0.448,-1 -1,-1h-4.417c-0.552,0 -1,0.448 -1,1v5.291c0,0.552 0.447,0.999 1,0.999Z" />
        <path d="M10.15,9.73v-1.75c0,-0.552 0.448,-1 1,-1h4.45c0.552,0 1,0.448 1,1v5.291c0,0.552 -0.448,1 -1,1h-1.784" />
      </g>
    </svg>
  )
}

export { CopyIcon }
